export class PreApproveCustomerParams {
  customerCode: string;
  fiscalId: string;
  fiscalIdType: string;
  branchCode: string;
  limitRule: string;
  salesOrg: string;
  sellerCode: string;
  menu: string;
  onbaseProcedureCode:string;
  productCode:string;

  constructor() {
    this.customerCode = '';
    this.fiscalId = '';
    this.fiscalIdType = '';
    this.branchCode = '';
    this.limitRule = '';
    this.salesOrg = '';
    this.sellerCode = '';
    this.menu = '';
    this.onbaseProcedureCode = '';
    this.productCode = '';
  }
}
